import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PoDropDownDto } from './po-drop-down.dto';


export class PoDropDownResponseModel extends GlobalResponseObject {
    data?: PoDropDownDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: PoDropDownDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

